import React from 'react';

const TemplatesIcon = (props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none" {...props}>
    <rect x="0.5" y="0.5" width="47" height="47" rx="5.5" fill="white" stroke="#EAEAEA" />
    <path
      d="M16.0792 35.679L10.337 25.3068C10.1162 24.908 10 24.4557 10 23.9952C10 23.5348 10.1162 23.0824 10.337 22.6836L16.0792 12.3117C16.3 11.9129 16.6176 11.5817 17 11.3514C17.3825 11.1212 17.8163 11 18.2579 11H29.7422C30.1838 11 30.6176 11.1212 31 11.3515C31.3824 11.5817 31.7 11.9129 31.9208 12.3117L37.6629 22.6836C37.8837 23.0824 38 23.5348 38 23.9953C38 24.4558 37.8837 24.9082 37.6629 25.307L31.9208 35.679C31.7 36.0777 31.3824 36.4088 31 36.639C30.6176 36.8693 30.1838 36.9904 29.7422 36.9904H18.2579C17.8163 36.9905 17.3825 36.8693 17 36.639C16.6175 36.4088 16.3 36.0778 16.0792 35.679Z"
      fill="url(#templatesIconGradient)"
    />
    <path
      opacity="0.07"
      d="M35.7419 28.769L27.6367 20.3176L24 19.3027L20.7335 20.5688L19.4719 23.9963L20.4863 27.8125L29.2961 36.9894C29.2961 36.9894 30.4868 37.1178 31.1847 36.5184C31.8827 35.919 32.0469 35.4481 32.0469 35.4481L35.7419 28.769Z"
      fill="black"
    />
    <path
      d="M24.0002 18.7031C21.198 18.7031 18.9263 21.0722 18.9263 23.9946C18.9263 26.9168 21.198 29.2859 24.0002 29.2859C26.8023 29.2859 29.0738 26.9168 29.0738 23.9946C29.0738 21.0722 26.8021 18.7031 24.0002 18.7031ZM24.0002 28.0093C21.8739 28.0093 20.1502 26.2117 20.1502 23.9944C20.1502 21.777 21.8739 19.9797 24.0002 19.9797C26.1264 19.9797 27.8501 21.7773 27.8501 23.9946C27.8501 26.2119 26.1264 28.0093 24.0002 28.0093Z"
      fill="white"
    />
    <path
      d="M21.5918 23.7908V25.4356C21.8252 25.8533 22.1544 26.2041 22.5499 26.4564V23.7908H21.5918ZM23.4916 22.4043V26.8323C23.6546 26.8636 23.8213 26.8825 23.9926 26.8825C24.1488 26.8825 24.301 26.8654 24.4504 26.8394V22.4043H23.4916ZM25.4803 24.4743V26.4274C25.8821 26.161 26.2121 25.7919 26.4388 25.3553V24.4745L25.4803 24.4743ZM27.6514 27.2544L27.1257 27.803C27.0812 27.8495 27.0562 27.9126 27.0562 27.9783C27.0562 28.044 27.0812 28.1071 27.1257 28.1536L29.1196 30.2322C29.1642 30.2787 29.2247 30.3048 29.2877 30.3048C29.3508 30.3048 29.4112 30.2787 29.4558 30.2322L29.9815 29.6843C30.0257 29.6377 30.0505 29.5747 30.0505 29.5091C30.0505 29.4435 30.0257 29.3805 29.9815 29.3339L27.9874 27.2544C27.9427 27.2081 27.8823 27.1822 27.8194 27.1822C27.7564 27.1822 27.696 27.2081 27.6514 27.2544Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="templatesIconGradient"
        x1="24.0001"
        y1="11.0002"
        x2="24.0001"
        y2="36.9501"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4387FD" />
        <stop offset="1" stopColor="#4683EA" />
      </linearGradient>
    </defs>
  </svg>
);

export default TemplatesIcon;
